module.exports = __webpack_public_path__ + "img/Liam Farrell.365191bf.png";